export default "__VITE_ASSET__bf151180__"